import React from 'react';
import styled from 'styled-components';

import { Dialog, Typography } from '@mui/material';

import { colors } from '../../theme';

// import icons
import { ReactComponent as ClearIcon } from '../../assets/icons/clear-icon.svg';
import {render} from "react-dom";

interface TitleProps {
    titleColor: string
}

const DialogTemplate = (props: any) => {
    const { onClose, title, renderContent, disableClose, titleColor, disableTitleAutoUpperCase, disableCenteredContent } = props;
    return (
        <StyledDialog {...props} open fullWidth>
            {title && (
                <Title titleColor={titleColor}>
                    <Typography variant="h3">{disableTitleAutoUpperCase ? title : title.toUpperCase()}</Typography>
                    {!disableClose && <ClearIcon onClick={onClose} />}
                </Title>
            )}
            {disableCenteredContent
                ? <LeftAlignedContent>{renderContent()}</LeftAlignedContent>
                : <Content>{renderContent()}</Content>
            }
        </StyledDialog>
    );
};

export default DialogTemplate;

const StyledDialog = styled(Dialog)`
    && {
        .MuiDialog-paper {
            border-radius: 10px;
            padding: 20px;
        }

        .MuiPaper-root {
            overflow: auto !important;
        }
    }
`;

const Title = styled.div<TitleProps>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px;
    border-bottom: 1px solid rgba(51, 51, 51, 0.2);
    h3 {
        font-size: 16px;
        color: ${(props) => (props.titleColor ? props.titleColor : colors.blue.main)};
        font-weight: bold;
        margin: 0;
    }

    svg {
        width: 25px;
        height: auto;
        path {
            fill: ${(props) => (props.titleColor ? props.titleColor : colors.blue.main)};
        }
        &:hover {
            cursor: pointer;
            opacity: 0.8;
        }
    }
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 10px 0px 10px;
`;

const LeftAlignedContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 10px 10px 0px 10px;
`;
